import {
  type BillingState,
  type EpocusBillingStatus,
  RXDB_EPOCUS_BILLING_STATUS_COLLECTION_NAME,
} from "$global-providers/rxdb-provider/collections/epocus-billing-status";
import { useUser } from "$global-providers/user-provider/provider";
import { useCallback, useMemo } from "react";
import type { RxCollection } from "rxdb";
import { useRxData } from "rxdb-hooks";
import { useBillingCodesEnabled } from "./use-billing-codes-enabled";

export const INCOMPLETE_BILLING_STATES: readonly BillingState[] = [
  "DRAFT",
  "INCOMPLETE",
];

export const useMyIncompleteBillingStatuses = (): EpocusBillingStatus[] => {
  const { id: userId } = useUser();
  const billingCodesEnabled = useBillingCodesEnabled();
  const enabled = Boolean(billingCodesEnabled && userId);

  const query = useCallback(
    (collection: RxCollection<EpocusBillingStatus>) =>
      enabled
        ? collection.find({
            selector: {
              performerId: userId,
              status: { $in: [...INCOMPLETE_BILLING_STATES] },
            },
          })
        : undefined,
    [enabled, userId],
  );

  const { result } = useRxData<EpocusBillingStatus>(
    RXDB_EPOCUS_BILLING_STATUS_COLLECTION_NAME,
    query,
  );

  return useMemo(
    () =>
      enabled
        ? (result ?? []).map(
            (doc) => doc.toMutableJSON() as EpocusBillingStatus,
          )
        : [],
    [enabled, result],
  );
};
